import React from 'react'

const Approved = ({ color, size }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={`size-${size || 6}`} viewBox="0 0 24 24" fill="none" stroke={color || "white"} strokeWidth="2" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </svg>
  )
}

export default Approved